import {Plugin} from "@uppy/core";
import api from "../../util/api";

export class PluginUpload extends Plugin {
    constructor(uppy, opts) {
        super(uppy, opts);
        this.id = this.opts.id || "PluginUpload";
        this.type = "modifier";

        this.defaultLocale = {
            strings: {
                compressingImages: "Preparing upload...",
            },
        };

        const defaultOptions = {};

        this.opts = Object.assign({}, defaultOptions, opts);

        // we use those internally in `this.compress`, so they
        // should not be overriden
        delete this.opts.success;
        delete this.opts.error;

        this.prepareUpload = this.prepareUpload.bind(this);
        this.finishUpload = this.finishUpload.bind(this);
    }

    async prepareUpload(fileIDs) {
        const promises = fileIDs.map(async fileID => {
            const file = this.uppy.getFile(fileID);
            this.uppy.emit("preprocess-progress", file, {
                mode: "indeterminate",
                message: "Creating a new multimedia item",
            });
            let response = await api.post(
                this.opts.companionUrl + "/uppy/prepare",
                {file},
                {headers: this.opts.companionHeaders}
            );
            let newMeta = response.data.data;
            this.uppy.setFileMeta(fileID, Object.assign({}, newMeta));
        });

        const emitPreprocessCompleteForAll = () => {
            fileIDs.forEach(fileID => {
                const file = this.uppy.getFile(fileID);
                this.uppy.emit("preprocess-complete", file);
            });
        };

        // Why emit `preprocess-complete` for all files at once, instead of
        // above when each is processed?
        // Because it leads to StatusBar showing a weird “upload 6 files” button,
        // while waiting for all the files to complete pre-processing.
        return Promise.all(promises).then(emitPreprocessCompleteForAll);
    }

    async finishUpload(fileIDs) {
        const promises = fileIDs.map(async fileID => {
            const file = this.uppy.getFile(fileID);
            this.uppy.emit("postprocess-progress", file, {
                mode: "indeterminate",
                message: "Starting indexing process in parallel",
            });
            await api.post(this.opts.companionUrl + "/uppy/finish", {file}, {headers: this.opts.companionHeaders});
        });

        const emitPostprocessCompleteForAll = () => {
            fileIDs.forEach(fileID => {
                const file = this.uppy.getFile(fileID);
                this.uppy.emit("postprocess-complete", file);
            });
        };

        // Why emit `preprocess-complete` for all files at once, instead of
        // above when each is processed?
        // Because it leads to StatusBar showing a weird “upload 6 files” button,
        // while waiting for all the files to complete pre-processing.
        return Promise.all(promises).then(emitPostprocessCompleteForAll);
    }

    install() {
        this.uppy.addPreProcessor(this.prepareUpload);
        this.uppy.addPostProcessor(this.finishUpload);
    }

    uninstall() {
        this.uppy.removePreProcessor(this.prepareUpload);
        this.uppy.removePostProcessor(this.finishUpload);
    }
}
